import React, { Suspense } from 'react'

import { AppSpin } from '@/shared/ui'
const Loading = () => (
  <div style={{ textAlign: 'center', margin: '20px auto' }}>
    <AppSpin />
  </div>
)

const LazyLoad = ({ component: Component, ...rest }) => (
  <>
    <Suspense fallback={<Loading />}>
      <Component {...rest} />
    </Suspense>
  </>
)

export default LazyLoad
